import './confirmation-modal-container.component.scss';

import { memo, useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';

import ModalContainer from '../ModalContainer';
import MessageBoxGroup from 'components/MessageBoxGroup';
import Button from '../Button';

const ConfirmationChildren = props => {
  const {
    messages,
    messagesTypes,
    title,
    description,
    confirmButtonClassName,
    confirmButtonLabel,
    cancelButtonLabel,
    cancelButtonClassName,
    closeModal,
    onConfirm
  } = props;
  const { t } = useTranslation();

  const [multiMessages, setMultiMessages] = useState(cloneDeep(messages));
  const currentConfirmButtonLabel = confirmButtonLabel || 'Yes';
  const currentConfirmButtonClassName = confirmButtonClassName || 'btn-delete';
  const currentCancelButtonLabel = cancelButtonLabel || 'No';
  const currentCancelButtonClassName = cancelButtonClassName || 'btn-grey';

  useEffect(() => {
    setMultiMessages(cloneDeep(messages));
  }, [messages])

  return (
    <>
      <div className='header'>
        <div className='title'>{t(title)}</div>
      </div>
      <div className='body'>
        <MessageBoxGroup
          messages={multiMessages}
          SuccessMessagesType={messagesTypes.success}
          ErrorMessagesType={messagesTypes.error}
          WarningMessagesType={messagesTypes.warning}
          onClose={type => setMultiMessages({...multiMessages, [type]: ''})}
        />
        <div>
          {<span dangerouslySetInnerHTML={{ __html: description }}></span>}
        </div>
      </div>
      <div className='footer non-border-top-footer'>
        <Button
          label={t(currentCancelButtonLabel)}
          className={currentCancelButtonClassName}
          onClick={closeModal}
        />
        <Button
          label={t(currentConfirmButtonLabel)}
          className={currentConfirmButtonClassName}
          onClick={onConfirm}
        />
      </div>
    </>
  )
}

const ConfirmationModalContainer = props => {
  const {
    modalWidthType,
    messages, // Please follow the data format in defaultProps.
    messagesTypes, // Please follow the data format in defaultProps.
    title,
    description,
    confirmButtonLabel,
    confirmButtonClassName,
    cancelButtonLabel,
    cancelButtonClassName,
    openModal,
    closeModal,
    onConfirm,
  } = props;

  return (
    <ModalContainer
      {...{openModal}}
      {...{modalWidthType}}
      {...{closeModal}}
      children={
        <ConfirmationChildren
          {...{messages}}
          {...{messagesTypes}}
          {...{title}}
          {...{description}}
          {...{confirmButtonLabel}}
          {...{confirmButtonClassName}}
          {...{cancelButtonLabel}}
          {...{cancelButtonClassName}}
          {...{closeModal}}
          {...{onConfirm}}
        />
      }
    />
  );
}

ConfirmationChildren.defaultProps = {
  messages: {
    success: null,
    error: null,
    warning: null
  },
  messagesTypes: {
    success: 'i18n',
    error: 'i18n',
    warning: 'i18n'
  }
};

export default memo(ConfirmationModalContainer);